import SERVER_URL from '@/config'

const feathers = require('@feathersjs/feathers')
const socketio = require('@feathersjs/socketio-client')
const io = require('socket.io-client')
const auth = require('@feathersjs/authentication-client')

const socket = io(SERVER_URL, {
  transports: ['websocket']
})

const feathersClient = feathers()
  .configure(socketio(socket, {
    timeout: 10 * 60 * 1000
  }))
  .configure(auth({
    storage: localStorage,
    storageKey: 'anl-auth',
    timeout: 60 * 1000
  }))

export default feathersClient
